import { render } from "./Main.vue?vue&type=template&id=59c04f2d&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=59c04f2d&lang=less&scoped=true"
import "./Main.vue?vue&type=style&index=1&id=59c04f2d&lang=less"
script.render = render
script.__scopeId = "data-v-59c04f2d"

export default script